// src/utils/timeTicker.js
import Vue from 'vue'
import moment from 'moment'

const state = Vue.observable({
  now: moment()
})

let timerId = null

function startTimeTicker () {
  // 이미 돌고 있으면 또 만들지 않음 (중복 방지)
  if (timerId !== null) return

  const tick = () => {
    state.now = moment()
  }

  tick() // 최초 1번 즉시 실행
  timerId = setInterval(tick, 60000) // 1분마다 갱신
}

function stopTimeTicker () {
  if (timerId !== null) {
    clearInterval(timerId)
    timerId = null
  }
}

export {
  state as timeState,
  startTimeTicker,
  stopTimeTicker
}